module.exports = {
	name: 'boolean',
	validation(yup) {
		return yup.boolean();
	}
};
